import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class BoosterKind extends Cloneable {
    static NONE = new BoosterKind(0, "NONE");

    static _values = [
        this.NONE,
        new BoosterKind(1, "MAGNET"),
        new BoosterKind(2, "DYNAMITE"),
        new BoosterKind(3, "MERGE")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, BoosterKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof BoosterKind) {
            return BoosterKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return BoosterKind.NONE.equal(value);
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof BoosterKind) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new BoosterKind());
        } else if (target instanceof BoosterKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(BoosterKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});